import { TBoardId } from '../../../../../../../../types/types';
import { ThunkAction } from '../../../../../../../../types/actions';
import { getBoardExportSettings } from '../../../../../../../../store/model/board/selectors/getBoardExportSettings';
import { boardSetExportSettings } from '../../../../../../../../rest/effects/board/boardSetExportSettings';

export const onTrimTimeToggle = (
    boardId: TBoardId
): ThunkAction => {
    return (
        dispatch,
        getState
    ) => {
        const settings = getBoardExportSettings(getState(), boardId);
        const trimTime = !(settings && settings.trimTime);
        return dispatch(boardSetExportSettings(boardId, {
            ...settings,
            trimTime
        }))
    }
}
